import React, { useContext } from 'react';
import { AuthContext } from '../../../context/AuthContext';
import RejectedAgentContainer from './components/RejectedAgentContainer';

const Dashboard = () => {
    const { statusCode, agentId } = useContext(AuthContext);


    return (
      <div>
        {(statusCode === '0' || statusCode === '2') ? (
          <RejectedAgentContainer agentId={agentId} statusCode={statusCode} />
        ) : null}
      </div>
    );
};

export default Dashboard;
